import React from 'react';
import "./skills.css";
import "./skills.scss";
import { FaDocker, FaAws } from 'react-icons/fa';
import { SiGit, SiMicrosoftazure, SiRedis, SiFirebase } from 'react-icons/si';

const Others = () => {
  return (
    <div className="skills__content box-bottom-right">
        <h3 className="skills__title">DevOps & Cloud</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <FaDocker size={20} />
                    <div>
                        <h3 className="skills__name">Docker</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiGit size={20} />
                    <div>
                        <h3 className="skills__name">Git</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiRedis size={20} />
                    <div>
                        <h3 className="skills__name">Redis</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <FaAws size={20} />
                    <div>
                        <h3 className="skills__name">AWS</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiMicrosoftazure size={20} />
                    <div>
                        <h3 className="skills__name">Azure</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiFirebase size={20} />
                    <div>
                        <h3 className="skills__name">Firebase</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Others